<template>
  <div id="data-lists">
    <loading v-if="isLoading"></loading>
    <div class="info" v-if="!isLoading">
      <div class="breadcrumbs">
        <router-link :to="{name:'home'}">Datos Abiertos</router-link>
        / {{pageTitle}}
      </div>
      <div class="no-results" v-if="files.length == 0">
        Lo sentimos no encontramos ningún resultado con este criterio.
      </div>
      <div class="table table-condensed table-striped table-responsive" v-if="files.length > 0">
        <table class="table">
          <thead>
          <tr>
            <th class="" style="width: 50%">Descripción</th>
            <th class="" style="width: 25%">Tema</th>
            <th class="" style="width: 25%">Área</th>
          </tr>
          </thead>
          <tbody>
          <!-- TR - fileRow -->
          <filerow v-for="file in files" :title="file.title" :link="file.permalink" :modified="file.modified" :term="file.topics[0].title" :area="file.areas[0].title" :key="file.permalink"></filerow>
          </tbody>
        </table>
      </div>
      <div id="pagination-holder">
        <paginate
          v-if="numpages > 1"
          :page-count="numpages"
          :prev-text="'Anterior'"
          :next-text="'Siguente'"
          :container-class="'pagination justify-content-center'"
          :page-link-class="'page-link'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-class="'page-item'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :initial-page="page"
          :click-handler="doNavigation"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  /* global datos_abiertos */

  import axios from 'axios';
  import VuejsPaginate from 'vuejs-paginate';

  import filerow from './fileRow';
  import Loading from './Loading';

  export default {
    name: 'lists',
    components: {
      filerow,
      paginate: VuejsPaginate,
      Loading,
    },
    data() {
      return {
        pageTitle: 'Más recientes',
        error: [],
        files: [],
        page: 1,
        numpages: 1,
        isLoading: false,
      };
    },
    methods: {
      changeTitle(route) {
        let title = '';
        switch (route.params.type) {
          case 'tematica':
            title = 'Temáticas';
            break;
          case 'tag':
            title = 'Palabras Clave';
            break;
          case 'area':
            title = 'Áreas';
            break;
          case 'search':
            title = `Busqueda / ${route.params.slug}`;
            break;
          default:
            title = 'Más recientes';
        }

        this.pageTitle = title;
      },
      loadData(route, pageNum) {
        this.isLoading = true;
        const page = pageNum ? pageNum : 1;
        const apiUrl = datos_abiertos.api_url;
        const data = {
          'taxonomy': route.params.type,
          'term': route.params.slug,
          'page': page,
        };

        axios.post(`${apiUrl}/wp-json/datos-abiertos/v1/datos`, data).then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.files = response.data.posts;
            this.numpages = response.data.numpages;
            this.page = response.data.page;
          }
        }).catch((e) => {
          this.error = e;
          console.log(this.error);
        });
      },
      doNavigation(pageNum) {
        this.loadData(this.$route, pageNum);
      },
    },
    created() {
      this.changeTitle(this.$route);
      this.loadData(this.$route);
    },
    watch: {
      $route: function(value) {
        this.changeTitle(value);
        this.loadData(value);
      },
    },
  };
</script>

<style>
  #data-lists {
    font-size: 16px;
  }

  #data-lists a > p {
    color: #ed008c !important;
    text-decoration: underline;
    font-weight: bold;
    font-size: 14px;
  }

  #data-lists .table-striped tbody tr:nth-of-type(odd) {
    background-color: white;
  }

  #pagination-holder {
    font-size: 14px;
    font-weight: 300;
  }

  .breadcrumbs {
    margin-bottom: 20px;
    text-transform: uppercase !important;
    font-size: 14px;
  }

  .breadcrumbs a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// Lists.vue?780191e3